import { tscope } from '@i18n';
import * as PDF from '@lib/PDF';
import { MEGABYTE } from '@lib/storageSize';

export const ts = tscope('FormResolver');

const getIsValidSize = ({ file }) => file?.size <= 10 * MEGABYTE;

const getIsPDFFile = ({ file }) => file?.type === 'application/pdf';

export const fileValidator = async ({ file, password }) => {
  let errorMessage;
  let errorCode;

  if (!getIsValidSize({ file })) errorMessage = ts('fileSize');
  try {
    if (getIsPDFFile({ file })) await PDF.validatePassword({ file, password });
  } catch (error) {
    if (!error.reason) errorMessage = ts('PDFFileFailedToRead');
    if (error.reason === 'NEED_PASSWORD') errorMessage = ts('fileNeedsPassword');
    if (error.reason === 'INVALID_PASSWORD') errorMessage = ts('invalidPassword');
    errorCode = error.reason;
  }

  return errorMessage
    ? {
      type: 'danger',
      message: errorMessage,
      errorCode,
    }
    : null;
};
